import { api } from '@/utils/api';

/**
 * Hook that provides mutations for contact actions (send message, send connection, schedule quick action).
 * All mutations invalidate both contact.byId and history.contact to ensure the Campaign & History tab updates.
 */
export function useContactActionMutations(contactId: string) {
  const utils = api.useUtils();

  const invalidateContactData = () => {
    void utils.contact.byId.invalidate({ contactId });
    void utils.history.contact.invalidate({ contactId });
  };

  const sendMessageViaMutation = api.contact.sendMessageViaUnipile.useMutation({
    onSuccess: invalidateContactData,
  });

  const sendConnectionViaMutation = api.contact.sendConnectionViaUnipile.useMutation({
    onSuccess: invalidateContactData,
  });

  const scheduleQuickActionMutation = api.aiStep.scheduleQuickAction.useMutation({
    onSuccess: () => {
      invalidateContactData();
      void utils.aiStep.fetchNext.invalidate();
    },
  });

  return {
    sendMessageViaMutation,
    sendConnectionViaMutation,
    scheduleQuickActionMutation,
  };
}
